<template>
  <span
    class="CombatTeamScore"
    :style="{ '--mixtmt_mixvw': cssDynamicObj.mixvw }"
  >
    <span class="teamInfor">
      <span class="teamLogo">
        <img :src="datas[0].teamLogo" />
      </span>
      <span class="teamName" v-text="datas[0].teamName"></span>
      <span class="win_icon" v-if="datas[0].winFlag - 0"></span>
    </span>
    <span class="scoreArea">
      <span class="score" v-text="datas[0].teamScore"></span>
      <span class="vs" v-text="'-'"></span>
      <span class="score" v-text="datas[1].teamScore"></span>
    </span>
    <span class="teamInfor">
      <span class="teamLogo">
        <img :src="datas[1].teamLogo" />
      </span>
      <span class="teamName" v-text="datas[1].teamName"></span>
      <span class="win_icon" v-if="datas[1].winFlag - 0"></span>
    </span>
  </span>
</template>

<script>
export default {
  name: 'CombatTeamScore',
  props: {
    datas: {
      type: Array,
      default: () => {
        return []
      },
    },
    cssDynamicObj: {
      type: Object,
      default: () => ({
        mixvw: 1,
        mixvh: 1,
        realyWidth: 0,
        realyHeight: 0,
      }),
    },
  },
}
</script>

<style lang="scss" scoped>
.CombatTeamScore {
  width: 100%;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: flex-start;
  height: auto;
  .teamInfor {
    position: relative;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    width: calc(9.03vw * var(--mixtmt_mixvw));
    height: calc(4.44vw * var(--mixtmt_mixvw));
    .teamLogo {
      position: relative;
      width: calc(3.33vw * var(--mixtmt_mixvw));
      height: calc(2.22vw * var(--mixtmt_mixvw));
      overflow: hidden;
      &::before {
        content: '\20';
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        width: 100%;
        height: 100%;
        border: 1px solid var(--mixtmt_greyColor5);
      }
      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .teamName {
      width: 100%;
      height: calc(1.388vw * var(--mixtmt_mixvw));
      line-height: calc(1.388vw * var(--mixtmt_mixvw));
      font-size: calc(1.11vw * var(--mixtmt_mixvw));
      text-align: center;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      color: var(--mixtmt_greyColor3);
      font-weight: bold;
    }
    .win_icon {
      display: block;
      position: absolute;
      top: 0;
      z-index: 2;
      width: calc(2.083vw * var(--mixtmt_mixvw));
      height: calc(1.388vw * var(--mixtmt_mixvw));
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center;
      background-image: var(--mixtmt_theme_win_icon);
    }
    &:first-child {
      .win_icon {
        left: 0;
      }
    }
    &:last-child {
      .win_icon {
        right: 0;
      }
    }
  }
  .scoreArea {
    width: calc(6.94vw * var(--mixtmt_mixvw));
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    background-color: var(--mixtmt_greyColor7);
    border-radius: calc(0.278vw * var(--mixtmt_mixvw));
    height: calc(2.083vw * var(--mixtmt_mixvw));
    margin-top: calc(0.064vw * var(--mixtmt_mixvw));
    .score {
      width: calc(50% - 0.694vw * var(--mixtmt_mixvw));
      text-align: center;
      font-size: calc(1.11vw * var(--mixtmt_mixvw));
      font-weight: bold;
      color: var(--mixtmt_greyColor3);
    }
    .vs {
      width: calc(1.388vw * var(--mixtmt_mixvw));
      text-align: center;
      font-size: calc(1.11vw * var(--mixtmt_mixvw));
      color: var(--mixtmt_greyColor4);
    }
  }
}
</style>
